export enum RequestListType {
  Inter_Reserv_Location = 'inter_reserv_location',
  Property_Registration = 'property_registration',
  Professional_Registration = 'professional_registration',
  Change_Location_Data = 'change_location_data',
  Change_Professional_Data = 'change_professional_data',
}

export enum FromScratcFormFormType {
  RegisteredForm = 1,
  AnonyumousForm = 2,
  RegisteredFormWithProtokolSide = 3,
  RegisteredFormWithProtokolEmail = 4,
}

export enum SectorDictionary {
  Education = 'education',
  Digitization = 'digitization',
  Investment = 'investment',
}

export enum UnitDictionary {
  Manag_Education = 'mang_education',
  Manag_Digitization = 'manag_digitization',
  Manag_Invastment = 'manag_investment',
  Film_Office_A = 'film_office_A',
  Film_Office_B = 'film_office_B',
}

export const Status = {
  Unassigned: 'unassigned',
  Under_update: 'under_update',
  In_progress: 'in_progress',
  Success: 'successful',
  Rejected: 'rejected',
};

export const StatusDictionary = {
  [Status.Unassigned]: 'Μη ανατεθειμένο',
  [Status.In_progress]: 'Σε επικαιροποίηση',
  [Status.Under_update]: 'Υπό διεκπεραίωση',
  [Status.Success]: 'Επιτυχές',
  [Status.Rejected]: 'Απορριφθέν',
};

export const request_list_type_options = [
  {
    key: 'Αίτημα Ενδιαφέροντος/Κράτησης Τοποθεσίας',
    value: RequestListType.Inter_Reserv_Location,
  },
  {
    key: 'Αίτημα Καταχώρισης Ιδιοκτησιας',
    value: RequestListType.Property_Registration,
  },
  {
    key: 'Αίτημα Καταχώρισης Επαγγελματία',
    value: RequestListType.Professional_Registration,
  },
  {
    key: 'Αίτημα Αλλαγής Στοιχείων Τοποθεσίας',
    value: RequestListType.Change_Location_Data,
  },
  {
    key: 'Αίτημα Αλλαγή Στοιχείων Επαγγελματία',
    value: RequestListType.Change_Professional_Data,
  },
];

export const request_status_options = [
  {
    key: StatusDictionary[Status.Unassigned],
    value: Status.Unassigned,
  },
  {
    key: StatusDictionary[Status.In_progress],
    value: Status.In_progress,
  },
  {
    key: StatusDictionary[Status.Under_update],
    value: Status.Under_update,
  },
  {
    key: StatusDictionary[Status.Success],
    value: Status.Success,
  },
  {
    key: StatusDictionary[Status.Rejected],
    value: Status.Rejected,
  },
];

export const sector_options = [
  {
    key: 'Εκπαίδευση',
    value: SectorDictionary.Education,
  },
  {
    key: 'Ψηφιοποίηση',
    value: SectorDictionary.Digitization,
  },
  {
    key: 'Επένδυση',
    value: SectorDictionary.Investment,
  },
];

export const unit_options = [
  {
    key: 'Διεύθυνση Εκπαίδευσης',
    value: UnitDictionary.Manag_Education,
  },
  {
    key: 'Διεύθυνση Ψηφιοποίησης',
    value: UnitDictionary.Manag_Digitization,
  },
  {
    key: 'Διεύθυνση Επένδυσης',
    value: UnitDictionary.Manag_Invastment,
  },
  {
    key: 'Film Office A',
    value: UnitDictionary.Film_Office_A,
  },
  {
    key: 'Film Office B',
    value: UnitDictionary.Film_Office_B,
  },
];

export const operator_options = [
  {
    key: 'Γεώργιος Γεωργίου',
    value: 'name 1',
  },
  {
    key: 'Ιωάννα Γιαννοπούλου',
    value: 'name 2',
  },
];
